import FlowStep from "./components/FlowStep";
import FlowSwitch from "./components/FlowSwitch";
import FlowControllerContext from "./context/FlowControllerContext";
import FlowController, { FlowCtxComponent } from "./FlowController";
var Flow = {
  Context: FlowControllerContext,
  Controller: FlowController,
  Step: FlowStep,
  ContextComponent: FlowCtxComponent,
  Switch: FlowSwitch
};
export { default as useFlowContext } from "./context/useFlowContext";
export { Flow };
export default Flow;